import { Badge, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  MinimumRequirementOutcome,
  type EvalBidDto,
  type EvalMinimumRequirementsDto,
} from "../../../../autogen/bff-api";

export const failsMinimumRequirement = (bid: EvalBidDto): boolean =>
  bid.minimumRequirements?.outcome === MinimumRequirementOutcome.NotFulfilled;

export const hasUnassessedMinimumRequirements = (bid: EvalBidDto): boolean =>
  bid.minimumRequirements?.outcome === MinimumRequirementOutcome.Pending;

export const MinimumRequirementOutcomeBadge = ({
  minimumRequirements,
}: {
  minimumRequirements?: EvalMinimumRequirementsDto | null;
}) => {
  const { t } = useTranslation();
  const outcome = minimumRequirements?.outcome;
  if (minimumRequirements == null || outcome === MinimumRequirementOutcome.Fulfilled) return null;

  const { fulfilled, notFulfilled, total } = minimumRequirements;
  if (outcome === MinimumRequirementOutcome.NotFulfilled) {
    return (
      <Tooltip
        label={t("{{notFulfilled}} of {{total}} minimum requirements are not fulfilled", {
          notFulfilled,
          total,
        })}
      >
        <Badge colorScheme="red">{t("Minimum requirement not fulfilled")}</Badge>
      </Tooltip>
    );
  }
  return (
    <Tooltip
      label={t("{{reviewed}} of {{total}} minimum requirements are assessed", {
        reviewed: fulfilled + notFulfilled,
        total,
      })}
    >
      <Badge colorScheme="orange">{t("Minimum requirements in progress")}</Badge>
    </Tooltip>
  );
};
